import React from "react";
import "./Products.css";

const products = [
  { id: 1, title: "Signature Blend", description: "A rich, bold blend perfect for your morning shot.", image: "/assets/specials/01.jpg" },
  { id: 2, title: "Grazing Boxes", description: "Everything you could want for any occasion.", image: "/assets/specials/02.jpg" },
  { id: 3, title: "Take away", description: "Get your lunch to go.", image: "/assets/specials/08.jpg" },
  { id: 4, title: "Loaded", description: "Freshly made and loaded with flavour.", image: "/assets/specials/04.jpg" },
  { id: 5, title: "House Blend", description: "Perfect everyday coffee with balanced flavour.", image: "/assets/specials/05.jpg" },
  { id: 6, title: "Muffin delight", description: "Melt in your mouth.", image: "/assets/specials/06.jpg" },
  { id: 7, title: "Local Special", description: "Our local favorite.", image: "/assets/specials/07.jpg" },
  { id: 8, title: "Fruit Plate", description: "Summer Fruits to delight your taste buds.", image: "/assets/specials/03.jpg" },
  { id: 9, title: "Champions Breaky", description: "Start your day the right way.", image: "/assets/specials/09.jpg" }
];

export default function Products() {
  return (
    <section className="products-section">
      <div className="page-content">
        <h2 className="products-title">Our Specials</h2>

        <div className="products-marquee">
          <div className="products-row">
            {products.map((item) => (
              <div className="product-card" key={`a-${item.id}`}>
                <img src={item.image} alt={item.title} className="product-image" />
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
            {products.map((item) => (
              <div className="product-card" key={`b-${item.id}`}>
                <img src={item.image} alt={item.title} className="product-image" />
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
